import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  getHoldingWithApartmentSchemaWithAdditionalFields,
  holdingWithApartmentSchema,
} from "./holding-with-apartment";
import {
  getLeaseWithApartmentSchemaWithAdditionalFields,
  leaseWithApartmentSchema,
} from "./lease-with-apartment";
import { getSubletSchemaAdditionalFields, subletSchema } from "./sublet";

export const subletWithHoldingOrLeaseAndApartmentSchema = z.union([
  subletSchema.extend({
    holding: holdingWithApartmentSchema,
    issueCount: z.number().int().nonnegative().default(0),
  }),
  subletSchema.extend({
    lease: leaseWithApartmentSchema,
    issueCount: z.number().int().nonnegative().default(0),
  }),
]);

export type SubletWithHoldingOrLeaseAndApartment = z.infer<
  typeof subletWithHoldingOrLeaseAndApartmentSchema
>;

export function getSubletWithApartmentSchemaWithAdditionalFields(additionalFields: {
  sublet: typeof additionalDataSchema;
  holding: typeof additionalDataSchema;
  lease: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
  apartment: typeof additionalDataSchema;
}): typeof subletWithHoldingOrLeaseAndApartmentSchema {
  return z.union([
    getSubletSchemaAdditionalFields(additionalFields).extend({
      holding:
        getHoldingWithApartmentSchemaWithAdditionalFields(additionalFields),
      issueCount: z.number().int().nonnegative().default(0),
    }),
    getSubletSchemaAdditionalFields(additionalFields).extend({
      lease: getLeaseWithApartmentSchemaWithAdditionalFields(additionalFields),
      issueCount: z.number().int().nonnegative().default(0),
    }),
  ]);
}
